'use client';

import Link from 'next/link';

import { cn } from '@/utilities/cn';
import { NAV } from '@/constants';
// import { useIsLightText } from '@/reactHooks';

export function Breadcrumbs({
  segments,
  className,
  dotClassName,
  lastItemClassName,
}: {
  segments: {
    name: string | undefined;
    link?: string | undefined;
  }[];
  className?: string;
  dotClassName?: string;
  lastItemClassName?: string;
}) {
  // const isLightText = useIsLightText();

  return (
    <ul
      className={cn(
        'ps mb-5 flex flex-wrap items-center gap-1 md:hidden',
        // isLightText && 'text-base-100',
        className,
      )}
    >
      <li>
        <Link href={NAV.home}>Главная</Link>
      </li>

      {segments
        .filter((i) => typeof i.name !== 'undefined')
        .map((i, idx, arr) => (
          <li className="flex-center gap-1" key={i.name}>
            /
            {/* <svg
              className={cn(
                'fill-gray-300',
                isLightText && 'fill-gray-400',
                dotClassName,
              )}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="9" r="2" />
            </svg> */}
            {i.link ? (
              <Link className="link" href={i.link}>
                {i.name}
              </Link>
            ) : (
              <span
                className={cn(
                  'opacity-50',
                  // isLightText && 'text-primary',
                  lastItemClassName,
                )}
              >
                {i.name}
              </span>
            )}
          </li>
        ))}
    </ul>
  );
}
